module.exports = __webpack_public_path__ + "static/media/banner-deusto.d6156f38.jpg";